import { Outlet, useLocation } from "react-router-dom";
import MainNavigation from "../components/common/main-nav/MainNavigation";
import ResponseNotification from "../components/common/ResponseNotification";

const Main = () => {
  const location = useLocation();
  const activePath = location.pathname;

  return (
    <div>
      <MainNavigation activePath={activePath} />
      <ResponseNotification />
      <Outlet />
    </div>
  )
}

export default Main;